export default "__VITE_ASSET__Qc7vI0IH__";